/**
 * Short, bright reward chime — ~0.6s total.
 * High ascending notes for a crisp, addictive feel.
 */
export function playRewardSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();

    const master = ctx.createGain();
    master.gain.setValueAtTime(0.5, ctx.currentTime);
    master.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.7);
    master.connect(ctx.destination);

    // Light reverb
    const convolver = ctx.createConvolver();
    const impulse   = ctx.createBuffer(2, ctx.sampleRate * 0.4, ctx.sampleRate);
    for (let c = 0; c < 2; c++) {
      const ch = impulse.getChannelData(c);
      for (let i = 0; i < ch.length; i++)
        ch[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / ch.length, 3);
    }
    convolver.buffer = impulse;
    const revGain = ctx.createGain();
    revGain.gain.setValueAtTime(0.12, ctx.currentTime);
    convolver.connect(revGain);
    revGain.connect(master);

    // High bright notes: E6 G6 B6 E7
    // staggered 55ms, each lasts ~0.18s — total ~0.5s
    const notes  = [1318.51, 1567.98, 1975.53, 2637.02];
    const delays = [0, 0.055, 0.11, 0.17];

    notes.forEach((freq, i) => {
      const t = ctx.currentTime + delays[i];

      // Sine oscillator — pure bright tone
      const osc = ctx.createOscillator();
      const g   = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, t);

      g.gain.setValueAtTime(0, t);
      g.gain.linearRampToValueAtTime(i === notes.length - 1 ? 0.45 : 0.3, t + 0.008);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);

      osc.connect(g);
      g.connect(master);
      g.connect(convolver);
      osc.start(t);
      osc.stop(t + 0.25);

      // Thin triangle layer for shimmer — octave above
      const osc2 = ctx.createOscillator();
      const g2   = ctx.createGain();
      osc2.type = 'triangle';
      osc2.frequency.setValueAtTime(freq * 2, t);
      g2.gain.setValueAtTime(0, t);
      g2.gain.linearRampToValueAtTime(0.06, t + 0.008);
      g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.14);
      osc2.connect(g2);
      g2.connect(master);
      osc2.start(t);
      osc2.stop(t + 0.16);
    });

    setTimeout(() => ctx.close(), 1000);
  } catch (e) {
    console.warn('Audio not supported:', e);
  }
}
